import { render, staticRenderFns } from "./GroupOrder.vue?vue&type=template&id=b31a6b02&scoped=true&"
import script from "./GroupOrder.vue?vue&type=script&lang=js&"
export * from "./GroupOrder.vue?vue&type=script&lang=js&"
import style0 from "./GroupOrder.vue?vue&type=style&index=0&id=b31a6b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31a6b02",
  null
  
)

export default component.exports